import {HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';

/**
 * Protocol-relative API origin. Endpoints registered outside the `api` prefix
 * (Laravel's `/broadcasting/auth`) build off this instead of hand-rolling a
 * scheme + host.
 */
export function getApiOrigin(): string {
  return `//${environment.api.baseUrl}`;
}

export function getApiUrl(): string {
  return `${getApiOrigin()}/api/`;
}

export function getHeaders(): HttpHeaders {
  return new HttpHeaders();
}

